import { createBrowserRouter } from 'react-router-dom';
import App from './App';
import PrivateRoute from './components/Login/PrivateRoute';
import NotFound from './components/NotFound';
import Locations from './components/Locations/Locations';
import Editor from './components/Locations/Editor/Editor';
import Events from './components/Events/Events';
import Matchings from './components/Events/Matchings/Matchings';
import config from './config.json';
import React from 'react';
import HomePage from './components/HomePage/HomePage';
import Users from './components/Users/Users';
import Customers from './components/Customers/Customers';
import ImageOverview from './components/ImageOverview/ImageOverview';
import { Roles } from './constants/roles';

function createRoutes( ) {
  const getComponentByLabel = label => {
    const componentMap = {
      Home: <HomePage />,
      Events: <Events />,
      Locations: <Locations />,
      Images: <ImageOverview />,
      Customers: <Customers />,
      Users: <Users />,
    };
    return componentMap[label] || null;
  };

  return config.menuItems.children.map((entry) => {
    const { key, label } = entry;
    const mainElement = getComponentByLabel(label);

    const subRoutes = [];

    if (key === 'locations') {
      subRoutes.push({
        path: 'editor',
        element: <Editor />
      });
    }

    if (key === 'events') {
      subRoutes.push({
        path: 'matchings',
        element: <Matchings />
      });
    }

    let requiredRoles;
    switch (label) {
      case 'Home':
        requiredRoles = [Roles.SYSTEM_ADMIN, Roles.CUSTOMER_ADMIN, Roles.USER];
        break;
      case 'Events':
        requiredRoles = [Roles.SYSTEM_ADMIN, Roles.CUSTOMER_ADMIN, Roles.USER];
        break;
      case 'Locations':
        requiredRoles = [Roles.SYSTEM_ADMIN, Roles.CUSTOMER_ADMIN, Roles.USER];
        break;
      case 'Images':
        requiredRoles = [Roles.SYSTEM_ADMIN, Roles.CUSTOMER_ADMIN, Roles.USER];
        break;
      case 'Customers':
        requiredRoles = [Roles.SYSTEM_ADMIN];
        break;
      case 'Users':
        requiredRoles = [Roles.SYSTEM_ADMIN, Roles.CUSTOMER_ADMIN];
        break;
      default:
        requiredRoles = [Roles.SYSTEM_ADMIN, Roles.CUSTOMER_ADMIN, Roles.USER];
    }

    return {
      path: key,
      element: <PrivateRoute requiredRoles={requiredRoles}/>,
      children: [
        {
          index: true,
          element: mainElement,
        },
        ...subRoutes
      ],
    };
  });
}

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    errorElement: <NotFound />,
    children: [
      {
        path: 'locations',
        element: <Locations />
      },
      ...createRoutes(),
      {
        path: '*',
        element: <NotFound />
      }
    ]
  }
]);

export default router;
